/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_TransmissionInputs */

const en_field_transmission = /** @type {(inputs: Field_TransmissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transmission`)
};

const es_field_transmission = /** @type {(inputs: Field_TransmissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transmisión`)
};

const fr_field_transmission = /** @type {(inputs: Field_TransmissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transmission`)
};

const de_field_transmission = /** @type {(inputs: Field_TransmissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Getriebe`)
};

const ja_field_transmission = /** @type {(inputs: Field_TransmissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トランスミッション`)
};

const zh_field_transmission = /** @type {(inputs: Field_TransmissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`变速箱`)
};

const ar_field_transmission = /** @type {(inputs: Field_TransmissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ناقل الحركة`)
};

const id_field_transmission = /** @type {(inputs: Field_TransmissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transmisi`)
};

const it_field_transmission = /** @type {(inputs: Field_TransmissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trasmissione`)
};

const ru_field_transmission = /** @type {(inputs: Field_TransmissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Коробка передач`)
};

const pt_field_transmission = /** @type {(inputs: Field_TransmissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transmissão`)
};

const ko_field_transmission = /** @type {(inputs: Field_TransmissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`변속기`)
};

/**
* | output |
* | --- |
* | "Transmission" |
*
* @param {Field_TransmissionInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_transmission = /** @type {((inputs?: Field_TransmissionInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_TransmissionInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_transmission(inputs)
	if (locale === "es") return es_field_transmission(inputs)
	if (locale === "fr") return fr_field_transmission(inputs)
	if (locale === "de") return de_field_transmission(inputs)
	if (locale === "ja") return ja_field_transmission(inputs)
	if (locale === "zh") return zh_field_transmission(inputs)
	if (locale === "ar") return ar_field_transmission(inputs)
	if (locale === "id") return id_field_transmission(inputs)
	if (locale === "it") return it_field_transmission(inputs)
	if (locale === "ru") return ru_field_transmission(inputs)
	if (locale === "pt") return pt_field_transmission(inputs)
	return ko_field_transmission(inputs)
});